import {NgModule} from '@angular/core';
import {IdentifierInputModule} from '../common/identifier-input/identifier-input.module';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {OtpModule} from './otp/otp.module';
import {PanVerificationComponent} from './pan-verification/pan-verification.component';
import {AcceptInvitationComponent} from './accept-invitation.component';
import {InvitationService} from '../../service/invitation.service';
import {BankService} from '../../service/bank.service';
import {DocumentService} from '../../service/document.service';
import {UserService} from '../../service/user.service';
import {AuthTokenInterceptor} from '../../http/interceptors/auth-token.interceptor';
import {HttpErrorInterceptor} from '../../http/interceptors/http-error.interceptor';
import {CommonSectionsModule} from '../common/common-sections.module';
import {
    MatButtonModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatProgressSpinnerModule,
    MatSelectModule
} from '@angular/material';
import {FileService} from '../../service/file.service';
import {PanAlreadyPresentPromptComponent} from '../../common/pan-validator/pan-already-present-prompt/pan-already-present-prompt.component';
import {MatExpansionModule} from '@angular/material/expansion';
import {PanAlreadyPresentPromptModule} from '../../common/pan-validator/pan-already-present-prompt/pan-already-present-prompt.module';
import {LenderEventsService} from '../../service/lender-events.service';

const materialImports = [MatFormFieldModule, MatInputModule, MatCheckboxModule, MatDatepickerModule, MatButtonModule,
    ReactiveFormsModule, MatProgressSpinnerModule, MatDialogModule, MatSelectModule, MatExpansionModule];

@NgModule({
    imports: [CommonModule, FormsModule, IdentifierInputModule, OtpModule, PanAlreadyPresentPromptModule, CommonSectionsModule, MatProgressSpinnerModule, ...materialImports],
    declarations: [AcceptInvitationComponent, PanVerificationComponent],
    exports: [AcceptInvitationComponent],
    providers: [InvitationService, LenderEventsService, BankService, DocumentService, UserService, FileService, {
        provide: HTTP_INTERCEPTORS,
        useClass: AuthTokenInterceptor,
        multi: true
    }, {
        provide: HTTP_INTERCEPTORS,
        useClass: HttpErrorInterceptor,
        multi: true
    }],
    entryComponents: [PanAlreadyPresentPromptComponent]
})

export class AcceptInvitationModule {
}
